export const getDatedTakeout = store => store.datedTakeout
